
import React from "react";
import { IconPicker } from '../../../icons/IconPicker';

interface DrawerMenuItemIconProps {
    iconName: string
}
// todo: swap with IconPicker
export const DrawerMenuItemIcon = ({ iconName }: DrawerMenuItemIconProps) => {
    return (
        <IconPicker icon={iconName} size={24} className="pointer" />
    )
}
